import React, { Fragment } from 'react';

function QuestionPercentage({ onChange, questionId = '', label = '', value = '', autoFocus = true }) {
  return (
    <Fragment>
      {label && (
        <label htmlFor={'input-' + questionId} className="form__text-label">
          {label}
        </label>
      )}
      <input
        id={'input-' + questionId}
        type="number"
        onChange={onChange}
        min={1}
        max={100}
        value={value}
        autoFocus={autoFocus}
        className="new-assessment-detail__percentage-input"
      />
      <span className="new-assessment-detail__percent-sign">
        %
      </span>
    </Fragment>
  );
}

export default QuestionPercentage;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionPercentage.js